import React from "react";
import { MdOutlinePendingActions } from "react-icons/md";
import "./UpdateStatusButton.css";

export function UpdateStatusButton({ onClick, isActive }) {
  return (
    <div className="toolbar-button-wrapper">
      <button onClick={onClick} className="update-status-button">
        <MdOutlinePendingActions />
      </button>
      {isActive && <div className="button-underline update-status-underline" />}
    </div>
  );
}
